export class RestClient {

    public apiBase: string;

    constructor(apiBase?: string) {
        //this.apiBase = apiBase ?? location.protocol + '//' + location.hostname + ':5000' + '/api/v1/';
        if(location.hostname === 'localhost') {
            this.apiBase = apiBase ?? location.protocol + '//' + location.hostname + ':5000' + '/api/v1/';
        }else {
            this.apiBase = apiBase ?? location.protocol + '//' + location.hostname + '/api/v1/';
        }
        //this.apiBase = "https://labmanagement.de/api/v1/";
    }

    public async read<T>(
        resultType: new (source: any) => T,
        method: string,
        endPoint: string,
        payload: any
    ): Promise<T> {

        const header = new Headers();
        header.append('Content-Type', 'application/json');

        const request = new Request(this.apiBase + endPoint, {
            method: method,
            headers: header,
            mode: 'cors',
            cache: 'default',
            body: payload ? JSON.stringify(payload) : null
        });

        const result = await fetch(request);

        return new resultType(await result.json());
    }

    public async getCall<T>(
        resultType: new (source: any) => T,
        endPoint: string
    ): Promise<T> {

        return this.read(resultType, 'GET', endPoint, null);
    }



    public async putCall<T>(
        resultType: new (source: any) => T,
        endPoint: string,
        payload: any
    ): Promise<T> {

        return this.read(resultType, 'PUT', endPoint, payload);
    }

}
